var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"right-panel-header",staticStyle:{"padding":"10px"}},[_c('span',[_vm._v("Your Current Level")])]),(_vm.data.customer_id)?_c('LevelBlock'):_vm._e(),_c('FirstBlock'),_c('SecondBlock')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }